interface BrandMarkProps {
  compact?: boolean;
}

export function BrandMark({ compact = false }: BrandMarkProps) {
  return (
    <span className="brand-mark" aria-label="记忆星河">
      <svg
        className="brand-mark__symbol"
        viewBox="0 0 58 28"
        role="img"
        aria-hidden="true"
      >
        <path d="M4 22 19 13 31 16 45 5 54 12" />
        <circle cx="4" cy="22" r="1.8" />
        <circle cx="19" cy="13" r="1.8" />
        <circle cx="31" cy="16" r="1.8" />
        <circle cx="45" cy="5" r="1.8" />
        <circle cx="54" cy="12" r="1.8" />
      </svg>
      {compact ? null : <span className="brand-mark__text">记忆星河</span>}
    </span>
  );
}

